
import {ref} from 'vue';

export default {
  name: 'ModalDemo',

  setup() {
    return {
      modalVisible: ref(false),
    }
  }
}
